module.exports = __webpack_public_path__ + "img/Saudi-Arabia.7417eb8b.png";